import { render } from "./shoppingCart.vue?vue&type=template&id=036be770&scoped=true"
import script from "./shoppingCart.vue?vue&type=script&lang=js"
export * from "./shoppingCart.vue?vue&type=script&lang=js"

import "./shoppingCart.vue?vue&type=style&index=0&id=036be770&scoped=true&lang=less"

import exportComponent from "D:\\新建文件夹\\资料\\PC享赫生活\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036be770"]])

export default __exports__